import { render, staticRenderFns } from "./EventPerformanceChart.vue?vue&type=template&id=d3f5dcf4&"
import script from "./EventPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./EventPerformanceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports